import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LandingHeroComponent } from './landing-hero/landing-hero.component';
import { LoginGridBgModule } from '../account/auth/signin/cover/login-grid-bg.module';

/** Public front-door feature module (eager). Declares the hero landing and pulls
 *  in the shared magnetic-grid canvas. */
@NgModule({
	declarations: [LandingHeroComponent],
	imports: [CommonModule, RouterModule, LoginGridBgModule],
	exports: [LandingHeroComponent],
})
export class PublicModule {}
